// import { border } from "@material-ui/system";

const styles = () => ({
  root: {
    height: "calc(100vh - 160px)",
    overflow: "auto"
  },
  customRoot: {
    height: "calc(100vh - 197px)",
  },
  newEventButton: {
    width: 85,
    height: 32,
    padding: '8px 12px',
    background: '#26BBED',
    borderRadius: 0,
    color: 'white',
    boxShadow: 'none',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: 0.75,

    '&:hover': {
      background: '#26BBEDEE'
    }
  },
  eventListWrapper: {
    padding: "20px",
    background: "#f9f9f9 !important",
    // minHeight: "calc(100vh - 135px)",
    display: 'flex',
    flexFlow: 'column',
    height: "100%",
    overflow: "auto"
  },
  eventFiltersWrapper: {
    padding: '15px 20px',
    background: '#fff',
    border: "1px solid #dbd9d9"
  },
  noEventsWrapper: {
    marginTop: 12,
    flexGrow: 1,
    border: "1px solid #dadada",
    background: "#fff",
    display: 'flex',
    flexDirection: 'column'
  },
  noEventsText: {
    marginTop: 16
  },
  eventsListWrapper: {
    background: '#fff',
    marginTop: 10,
    border: "1px solid #dbd9d9"
  },
  modalTextArea: {
    height: 90,
    background: '#fff'
  },
  cancelButton: {
    color: '#333',
    borderRadius: 0,
    borderColor: '#999',
    fontSize: 14,
    fontWeight: 600
  },
  closeCancelModal: {
    color: '#333',
    borderRadius: 0,
    fontSize: 14,
    fontWeight: 600
  },
  description: {
    fontSize: 16,
    fontWeight: 400
  },
  cancelFieldLabel: {
    marginBottom: 4,
    marginTop: 24
  },
  cancelField: {
    borderRadius: 'none',
    border: '1px solid #dadada',
    padding: 12
  },
  searchBox: {
    width: 140,
  },
  verticalDivider: {
    marginLeft: 12,
    marginRight: 12
  },
  loadMore: {
    height: 60,
    background: '#FFFFFF',
    border: "1px solid #DADADA",
    fontWeight: 600,
    fontSize: 14,
    fontFamily: "Open Sans",
    fontStyle: "normal",
    marginTop: 24,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      background: "#f4fbfd"
    }
  },
  // Calendar styles
  headerWithDateRange: {
    height: 60,
    background: "#FFF",
    padding: "0 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid #F9F9F9"
  },
  headerText: {
    fontFamily: "Open Sans",
    fontSize: 24,
    lineHeight: "36px",
    color: "#333333"
  },
  hylyEvent: {
    textTransform: "none",
    padding: "6px 16px"
  },
  dialogRoot: {
    borderRadius: 0,
    width: 505,
    background: "white",
    overflowY: 'visible'
  },
  btnStyle: {
    textTransform: "none"
  },
  select_root: {
    fontFamily: "Open Sans",
    fontSize: 24,
    lineHeight: "36px",
    color: "#333333",
    border: 'none !important',
    paddingLeft: 0
  },
  select_list: {
    padding: "4px 0px",
    width: '150px'
  },
  select_menu: {
    padding: "8px 12px",
    height: 36,
    fontFamily: "Open Sans",
    fontSize: 14,
    lineHeight: "20px",
  }
});

export default styles;